
































































import Vue from 'vue';
import axios from 'axios';
import { defineComponent } from '@vue/composition-api';
import { accessor } from '../store';

export default defineComponent({
  data() {
    return {
      reservedNum: '',
      petitionName: '',
      wasteHandle: '',
      sector: '',
      permissionLimit: '',
      petitionTel: '',
      petitionPlace: '',
      petitionPlaceDisp: '',
      petitionType: '',
      petitionTypeDisp: '',
      reservedDate: '',
      reservedDateDisp: '',
      reservedTimeSpot: '',
      openDialog: false,
      dialogItems: {
        title: '',
        text: '',
        cancelCss: '',
        okCss: '',
        cancelBtnText: '',
        okBtnText: ''
      },
      cancelCall: function () {
        this.openDialog = false;
      },
      okCall: function () {
        this.openDialog = false;
      }
    };
  },
  mounted() {
    const resultData = this.$route.query.resultData;
    this.reservedNum = resultData.reservedNum;
    this.petitionName = resultData.petitionName;
    this.wasteHandle = resultData.wasteHandleStr;
    this.sector = resultData.sectorStr;
    this.permissionLimit = resultData.permissionLimit;
    this.petitionTel = resultData.petitionTel;
    this.petitionPlace = resultData.petitionPlace;
    this.petitionPlaceDisp = resultData.petitionPlaceDisp;
    this.petitionType = resultData.petitionType;
    this.petitionTypeDisp = resultData.petitionTypeDisp;
    this.reservedDate = resultData.reservedDate;
    this.reservedDateDisp = resultData.reservedDateDisp;
    this.reservedTimeSpot = resultData.reservedTimeSpot;
    accessor.setReservedNum(resultData.reservedNum);
    accessor.setPetitionType(resultData.petitionType);
    accessor.setPetitionPlace(resultData.petitionPlace);
    accessor.setPermissionLimit(resultData.permissionLimit);
    accessor.setPetitionDivision(resultData.petitionDivision);
    var nowDate = new Date().toLocaleDateString();
    var nowDateCalc = new Date(nowDate);
    var resDateCalc = new Date(this.reservedDate);
    this.diffDate = (resDateCalc.valueOf() - nowDateCalc.valueOf()) / 86400000;
  },
  methods: {
    doCancel() {
      this.openDialog = true;
      if (this.diffDate > 10) {
        this.dialogItems.text = 'ご予約をキャンセルします。\r\nよろしいですか？';
        this.dialogItems.cancelCss = 'orange';
        this.dialogItems.okCss = 'orange';
        this.dialogItems.cancelBtnText = '戻る';
        this.dialogItems.okBtnText = '予約キャンセルする';
        this.cancelCall = this.cancelBtn;
        this.okCall = this.doCancelBtn;
      } else {
        this.showMessage('予約日から10日前以降のキャンセル・変更など\r\nについては必ず申請場所に電話でご連絡ください。');
      }
    },
    doDateTime() {
      if (this.diffDate > 10) {
        this.$router.push({ path: 'choice', query: { newChangeFlagProps: 'change', petitionTypeProps: this.petitionType } });
      } else {
        this.showMessage('予約日から10日前以降のキャンセル・変更など\r\nについては必ず申請場所に電話でご連絡ください。');
      }
    },
    doPetitionType() {
      if (this.diffDate > 10) {
        var petitionTypeStr = '　　郵送';
        if (this.petitionType === '0') {
          this.okCall = this.doPetitionTypeBtn;
        } else {
          petitionTypeStr = '　　窓口';
          this.okCall = this.toTimeSpot;
        }
        this.dialogItems.text = '申請方法を\r\n' + this.petitionPlaceDisp + petitionTypeStr + '\r\nに変更します。\r\nよろしいですか？';
        this.dialogItems.cancelCss = 'white';
        this.dialogItems.okCss = 'orange';
        this.dialogItems.cancelBtnText = '戻る';
        this.dialogItems.okBtnText = '変更する';
        this.cancelCall = this.cancelBtn;
        this.openDialog = true;
      } else {
        this.showMessage('予約日から10日前以降のキャンセル・変更など\r\nについては必ず申請場所に電話でご連絡ください。');
      }
    },
    cancelBtn() {
      this.openDialog = false;
    },
    doCancelBtn() {
      this.openDialog = false;
      var that = this;
      var url = Vue.prototype.$API_URL + 'Change/CancelReservedInfo';
      const data = JSON.stringify({
        reservedNum: this.reservedNum
      });
      // server側へアクセス
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(function (response) {
          if (response.data) {
            // storeを初期化
            accessor.resetState();
            that.$router.push('/cancel');
          } else {
            that.showMessage('失敗しました。');
          }
        });
    },
    doPetitionTypeBtn() {
      this.openDialog = false;
      var that = this;
      var url = Vue.prototype.$API_URL + 'Change/ChangePetitionType';
      const data = JSON.stringify({
        reservedNum: this.reservedNum
      });
      // server側へアクセス
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(function (response) {
          if (response.data) {
            if (response.data.resultCode === 'FAILURE') {
              that.showMessage(response.data.resultMessage);
              return;
            }
            const info = response.data;
            that.$router.push({ path: 'comple', query: { resultData: info, classObject: 'compleChange' } });
          } else {
            that.showMessage('失敗しました。');
          }
        });
    },
    toTimeSpot() {
      this.openDialog = false;
      this.$router.push({ path: 'choice', query: { newChangeFlagProps: 'change', petitionTypeProps: '0' } });
    },
    showMessage(message) {
      this.openDialog = true;
      this.dialogItems.text = message;
      this.dialogItems.cancelCss = 'white';
      this.dialogItems.okCss = 'blue';
      this.dialogItems.cancelBtnText = '閉じる';
      this.dialogItems.okBtnText = '';
      this.cancelCall = this.cancelBtn;
    }
  }
});
